export default "__VITE_ASSET__CZP1ifNS__"